module.exports = __webpack_public_path__ + "static/media/a-t-and-t.4a5a7836.svg";